export const TID = {
  // Auth
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  logoutBtn: "logout-btn",

  // Layout
  sidebar: "sidebar",
  topbar: "topbar",
  searchInput: "global-search-input",
  viewGrid: "view-grid-btn",
  viewList: "view-list-btn",
  uploadBtn: "open-upload-btn",
  userMenu: "user-menu-btn",
  adminLink: "admin-link",

  // Folders
  folderTree: "folder-tree",
  folderItem: (id) => `folder-item-${id}`,
  newFolderBtn: "new-folder-btn",
  newFolderInput: "new-folder-name-input",
  newFolderSubmit: "new-folder-submit-btn",
  deleteFolderBtn: (id) => `delete-folder-${id}`,

  // Assets
  assetGrid: "asset-grid",
  assetCard: (id) => `asset-card-${id}`,
  emptyState: "empty-state",

  // Asset detail
  assetModal: "asset-detail-modal",
  closeAssetModal: "close-asset-modal-btn",
  assetTitleInput: "asset-title-input",
  assetDescInput: "asset-description-input",
  tagInput: "tag-input",
  addTagBtn: "add-tag-btn",
  tagChip: (t) => `tag-chip-${t}`,
  removeTag: (t) => `remove-tag-${t}`,
  saveAssetBtn: "save-asset-btn",
  deleteAssetBtn: "delete-asset-btn",
  refreshStatusBtn: "refresh-status-btn",

  // Upload
  uploadDialog: "upload-dialog",
  uploadFileInput: "upload-file-input",
  uploadStartBtn: "upload-start-btn",
  uploadProgress: (n) => `upload-progress-${n}`,
  uploadClose: "upload-close-btn",

  // Share
  shareDialog: "share-dialog",
  shareCloseBtn: "share-close-btn",
  shareTitleInput: "share-title-input",
  shareUsePassword: "share-use-password-toggle",
  sharePasswordInput: "share-password-input",
  shareExpirySelect: "share-expiry-select",
  shareReviewMode: "share-review-mode-toggle",
  shareAllowComments: "share-allow-comments-toggle",
  shareAllowApproval: "share-allow-approval-toggle",
  shareAllowDownload: "share-allow-download-toggle",
  shareCreateBtn: "share-create-btn",
  shareLinkUrl: "share-link-url",
  shareCopyBtn: "share-copy-btn",
  shareAssetBtn: "share-asset-btn",
  shareFolderBtn: "share-folder-btn",
  copyShareLinkBtn: "copy-share-link-btn",
  sharesLink: "shares-link",
  sharesList: "shares-list",
  deleteShareBtn: (id) => `delete-share-${id}`,

  // PDF reports
  reportAssetBtn: "report-asset-btn",
  reportFolderBtn: "report-folder-btn",

  // Favorites
  favoriteBtn: (id) => `favorite-btn-${id}`,
  favoritesLink: "favorites-link",

  // Collections
  collectionsLink: "collections-link",
  newCollectionBtn: "new-collection-btn",
  newCollectionInput: "new-collection-name-input",
  newCollectionSubmit: "new-collection-submit-btn",
  collectionItem: (id) => `collection-item-${id}`,
  addToCollectionBtn: "add-to-collection-btn",
  removeFromCollectionBtn: "remove-from-collection-btn",

  // Tag admin
  tagRenameBtn: (name) => `tag-rename-${name}`,
  tagDeleteBtn: (name) => `tag-delete-${name}`,
  tagRenameNew: "tag-rename-new-input",
  tagRenameSubmit: "tag-rename-submit-btn",

  // Admin
  adminUsersTab: "admin-users-tab",
  adminTagsTab: "admin-tags-tab",
  inviteEmail: "invite-email-input",
  inviteName: "invite-name-input",
  invitePassword: "invite-password-input",
  inviteRole: "invite-role-select",
  inviteSubmit: "invite-submit-btn",

  // Bulk selection
  bulkSelectToggle: "bulk-select-toggle",
  bulkSelectAll: "bulk-select-all-btn",
  bulkClear: "bulk-clear-btn",
  bulkActionBar: "bulk-action-bar",
  bulkDeleteBtn: "bulk-delete-btn",
  bulkMoveBtn: "bulk-move-btn",
  bulkTagBtn: "bulk-tag-btn",
  assetSelectCheckbox: (id) => `asset-select-${id}`,

  // Mark as resolved
  resolveCommentBtn: (id) => `resolve-comment-${id}`,

  // Embed health
  embedHealthBtn: "embed-health-btn",
  embedHealthResult: "embed-health-result",
};
